import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import DesignElements from './plugins/import-design-elements.js'
//import {mapActions} from 'vuex'
import './style.css'
import { VueMaskDirective } from 'v-mask'
import moment from 'moment';
import excel from 'vue-excel-export'

moment.updateLocale('ru', {
  week: {
    dow: 1, // Monday is the first day of the week.
  }
});
let defData = {};
defData.state = {};
defData.state.userInterface = true;

Vue.prototype.$moment = moment;

router.beforeEach((to, from, next) => {

  document.title = to.meta.title;
  
  if (to.matched.some(record => record.meta.requiresAuth) || to.matched.some(record => record.meta.requiresAdminAuth)) {

    if (localStorage.getItem('type')) {
      store.commit('setUserType', localStorage.getItem('type'));
    }

    if (localStorage.getItem('fio')) {
      store.commit('setUserFIO', localStorage.getItem('fio'));
    }

    if (localStorage.getItem('accessToken')) {
      store.commit('setUserInterface', defData);
      next()
    } else {
      next({ path: '/' })
    }
  } else if (to.matched.some(record => record.meta.logout)) {
    // Remove bearer token from localStorage
    localStorage.clear();
    store.commit('unSetUserInterface')
    next({
      path: '/'
    })
  } else {
    next()
  }
  
})
Vue.directive('mask', VueMaskDirective);
//Vue.directive('excel', excel);
Vue.use(excel);
new Vue({
  router,
  store,
  vuetify,
  excel,
  DesignElements,
  render: h => h(App)
}).$mount('#app')
